/**
 * helper method to prepend any value with a standard storm specific string identifier
 */
const createStormTaktId = id => id ? `storm-ui-${id}` : 'storm-ui-component';
const getDataTaktAttributesFunction = ({
  taktId,
  taktIdContext,
  taktValue: taktValueFromProvider,
  taktIdPrefix
}) => (params = {}) => {
  const {
    taktValue,
    contextOnlyTaktValues,
    taktIdSuffix
  } = params;
  const {
    taktFeatureChain,
    taktValues,
    taktPrefix,
    delimiter
  } = taktIdContext;
  const dataTaktAttributes = {};
  if (taktId) {
    const fullTaktId = [taktIdPrefix !== null && taktIdPrefix !== void 0 ? taktIdPrefix : taktPrefix, taktId, taktIdSuffix].filter(part => !!part).join('-');
    dataTaktAttributes['data-takt-id'] = fullTaktId;
  }
  if (taktFeatureChain !== null && taktFeatureChain !== void 0 && taktFeatureChain.length) {
    dataTaktAttributes['data-takt-feature'] = taktFeatureChain.join(delimiter) || undefined;
  }
  const dataTaktValue = {
    ...(taktFeatureChain !== null && taktFeatureChain !== void 0 && taktFeatureChain.length ? contextOnlyTaktValues : {}),
    ...(taktFeatureChain !== null && taktFeatureChain !== void 0 && taktFeatureChain.length ? taktValues : {}),
    ...taktValueFromProvider,
    ...taktValue
  };
  if (Object.keys(dataTaktValue).length !== 0) {
    dataTaktAttributes['data-takt-value'] = JSON.stringify(dataTaktValue);
  }
  return dataTaktAttributes;
};
const setDataTaktAttributesOnElement = (element, dataTaktAttributes = {}) => {
  if (dataTaktAttributes['data-takt-id']) {
    element === null || element === void 0 || element.setAttribute('data-takt-id', dataTaktAttributes['data-takt-id']);
  }
  if (dataTaktAttributes['data-takt-feature']) {
    element === null || element === void 0 || element.setAttribute('data-takt-feature', dataTaktAttributes['data-takt-feature']);
  }
  if (dataTaktAttributes['data-takt-value']) {
    element === null || element === void 0 || element.setAttribute('data-takt-value', dataTaktAttributes['data-takt-value']);
  }
};

export { createStormTaktId as c, getDataTaktAttributesFunction as g, setDataTaktAttributesOnElement as s };
//# sourceMappingURL=TaktIdContext.utils-B0CzqlN8.js.map
